import styled from '@emotion/styled';
export const StyledSectionHeader = styled.div `
  background: #fff;
`;
export const StyledSectionHeaderLabel = styled.div `
  align-items: center;
  background: rgba(0, 20, 60, 1);
  border: none;
  display: flex;
  height: 48px;
  outline: none;
  padding: 0 12px;
  width: 100%;
  box-sizing: border-box;
  color: #fff;
  flex: 1;
  font-family: Verdana, serif;
  font-size: 14px;
  line-height: 16px;
  text-align: left;
`;
export const StyledSectionHeaderContent = styled.div `
  height: auto;
  max-height: 9999px;
  overflow: hidden;
  transition: max-height 1s;
`;
